<template>
	<div class="excellentcases">
		
		<headerview :cur="4"></headerview>
		
		<div class="content">
			
			<div class="moddlecon w13">
				<div class="tipcon">
					<tipconNav :title="'标准队课'" :name="[{label:'学习资料',url:'/studytrain'},{label:'标准队课',url:'/excellentcases'}]" :imgtype="'2'" width="2.05"></tipconNav>
				</div>
				
				<div class="box f-row-start-l wrap"> 
					<div class="box-l">
						<div class="btn-lt f-row-c">案例导航</div>
						<div class="btn-lb">
							<div class="item f-row-c pinter" :class="actIndL==ind?'act':''" @click="onGrade(ind)" v-for="(item,ind) in  grade" :key='ind'>{{item.title||''}}</div>
						</div>
					</div>
					<div class="box-r"> 
						<div class="box-t f-row-l wrap">
							<div class="item f-row-c pinter" :class="actIndR1==ind?'act':''"  v-for="(item,ind) in  tabListR" :key='ind' @click="onTab(ind)">{{item.title||''}}</div>
						</div>
						<div class="box-b f-row-l wrap">
							<div class="item f-row-c pinter" :class="actIndR2==ind?'act':''"  v-for="(item,ind) in  tabListRChild" :key='ind' @click="onTab1(ind)">{{item.title||''}}</div>
						</div>

						<div class="listcon min-h f-row-start-l wrap">
							<div class="signle pinter" v-for="(item,index) in list" :key="index" @click="seedetail(item)">
								<el-image fit='cover' class="imgbox" :src='item.coverId_dictText?$fileAccessHttpUrl(item.coverId_dictText):""'></el-image>
								<div class="title overfh" :title="item.title">{{item.title||''}}</div>
							</div>
						</div>
					</div>
				</div>
				
				<!-- 分页 -->
				<div class="">
					<div is='footPage' class="zhini-pagination"
					  :currentPage="pageNo"
					  :totalPage="total"
					  @pageNum="pageNum"  :pagesize='pageSize'></div>
				</div>
				
			</div>
				
		</div>				
		
		<footview></footview>		
		
	</div>
	
</template>

<script>
import footPage from '../../../components/footpage/footpage.vue'
export default {
  components: {
	  footPage,
  },
  data: function() {
		return {
			grade:[],
			actIndL:null,
			actIndR1:0,
			actIndR2:null,
			tabListR:[],
			tabListRChild:[],
			list:[],
			pageNo:1,
			total:1,
			pageSize:9,
		  
		};
  },
  created(){
	  this.getSys('grade');
	  this.getSys('stair_type')
	  
  },
  mounted() {
		this.$onScrollT()
		// this.$nextTick(()=>{ 
		// 	this.init()
		// });
  },

  methods: {
	  	onGrade(ind){
			this.actIndL=ind;
			// this.actIndR1=0;
			// this.actIndR2=null;
			this.init()
		},
	  	onTab(ind){
			this.actIndR1=ind
			this.secondDictCode='';//二级分类
			var value=this.tabListR[ind].value
			if (value=='0')
				this.secondDictCode='org_awareness';
			if (value=='1')
				this.secondDictCode='politics_type';
			if (value=='2')
				this.secondDictCode='morality_type';
			if (value=='3')
				this.secondDictCode='grow_type';

			this.actIndR2=null;

			if(this.secondDictCode){ 
				this.getSys(this.secondDictCode)
			}else{ 
				this.tabListRChild=[]
			}
			
			this.init()
		},
		onTab1(ind){
			this.actIndR2=ind
			this.init()
		},
	  	getSys(sysVal){
			this.$get(`/web/info/getDictItems/${sysVal}`).then(res=>{
				if(res.success){
					if(sysVal=='grade'){ 
						this.grade=res.result
					}else if(sysVal=='stair_type'){ 
						this.tabListR=res.result
						this.tabListR.unshift({
							text: "全部案例",
							title: "全部案例",
							value: ""
						})
						this.init()
					}else{ 
						this.tabListRChild=res.result
					}
				}
			})
		},
		init(){
			this.pageNo=1;
			this.getCulturallist()
		},
		getCulturallist(){//web/culturalproduct/datalist
			// var geturl=`web/culturalproduct/datalist?pageSize=8&pageNo=${this.pageNo}&dataType=1`
			var geturl='web/culturalproduct/datalist'
			var params={ 
				pageSize:this.pageSize,
				pageNo:this.pageNo,
				dataType:1
			}
			if(this.actIndL||this.actIndL==0){ 
				params.grade=this.grade[this.actIndL].value
			}else{ 
				delete params.grade
			}
			
			if(this.actIndR1||this.actIndR1==0){ 
				params.stairType=this.tabListR[this.actIndR1].value
			}else{ 
				delete params.stairType
			}

			if(this.actIndR2||this.actIndR2==0){ 
				params.secondType=this.tabListRChild[this.actIndR2].value
			}else{ 
				delete params.secondType
			}

			this.$get(geturl,params).then(res=>{
				if(res.success){
					this.total = res.result.total//Math.ceil(res.result.total/8)
					this.list = res.result.records;
				}
			})
		},
	  
		seedetail(item){
			this.$router.push({ path: '/excellentcases_detail?id='+item.id +'&type=2'});			
		},
		
		pageNum(e) {
			this.pageNo = e;
			this.$onScrollT()
			this.getCulturallist()
		},
		
		
  },
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.excellentcases{
	
	.content{
		display: flex;
		justify-content: center;
		.moddlecon{
			background-color: #FFFFFF;
			padding: 20px 50px 0px 50px;
			box-sizing: border-box;
			.box{
				padding-top: 56px;
				.item{ 
					font-weight: 400;
					font-size: 18px;
					min-height: 56px;
				}
			}
			.box-l{ 
				width: 161px;
				border-radius: 8px 8px 0px 0px;
				
				.item,.btn-lt{ 
					position: relative;
					color: #666666;
				}
				.btn-lt{
					min-height: 56px;
					background: #FA9E1E;
					color: #ffffff;
					border-radius: 8px 8px 0px 0px;
					box-shadow: 0px 0px 1px #FA9E1E;
				}
				.btn-lb{ 
					box-shadow: 0px 0px 1px #CCCCCC;
				}
				.item::before,.act::before{
					content: '';
					position: absolute;
					width: calc(100% - 14px);
					height: 1px;
					background: rgba($color: #CCCCCC, $alpha: 0.2);
					left: 7px;
					bottom: 0px;
					z-index: 2;
				}
				.act{ 
					color: #FA9E1E;
				}
				.act::before{
					background: rgba($color: #FA9E1E, $alpha: 0.2);
				}
			}
			.box-r{ 
				width: calc(100% - 201px);
				margin-left: 40px;
				.item{ 
					margin-right: 18px;
					min-height: 44px;
					min-width: 116px;
					color: #666666;
					border-radius: 8px;
				}
				.box-t{ 
					margin-bottom: 24px;
					.item{
						background: #EEEEEE;
					}
				}
				.box-b{ 
					.item{ 
						min-height: 36px;
						min-width: 115px;
						border: 1px solid #CCCCCC;
					}
				}
				.act{
					background: #FA9E1E!important;
					color: #ffffff!important;
					border: 1px solid #FA9E1E!important;
				}
			}
			.listcon{
				margin-top: 50px;
				.signle{
					width: calc(33.33% - 17px);
					margin-left: 25px;
					margin-bottom: 49px;
					.title,.time{ 
						// cursor: pointer;
						font-size: 18px;
						font-weight: 400;
					}
					.imgbox{
						width: 315px;
						width: 100%;
						height: 178px;
					}
					.title{
						margin-top: 15px;
						color: #333333;
					}
					.time{
						color: #999999;
					}
				}
				.signle:nth-child(3n+1){ 
					margin-left:0px;
				}
				.signle:hover .title{
					color: #E61F26;
				}
				.signle:hover .time{
					color: #E61F26;
				}
				
			}
			
			
		}
	
	}		
	
	
	
}

</style>
